import React, { useEffect } from "react";
import { Button } from "primereact/button";
import { RadioButton } from "primereact/radiobutton";
import { SelectButton } from "primereact/selectbutton";

export default function Panel_D({ data, setData, onUploadDialog, uploadPic, disabledPage }) {
    useEffect(() => {
        // console.log('data ',data);
    }, [data]); //searchData

    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };

    const radioList = [
        [
            { id: 1, label: "- แนว", box: "pileInlineResult", codePic: "T402" },
            { id: 2, label: "- ระดับ", box: "pileLevelResult", codePic: "T403" },
            { id: 3, label: "- ดิ่ง", box: "pileVerticalResult", codePic: "T404" },
        ],
        [
            { id: 1, label: "- ดิ่ง", box: "concreteVerticalResult", codePic: "T405" },
            { id: 2, label: "- ถอดแบบตามกำหนด", box: "concretePatternResult", codePic: "T406" },
            { id: 3, label: "- บ่มคอนกรีต", box: "concreteCuringResult", codePic: "T407" },
        ],
    ];

    const verticalOptions = [
        { label: "ตรงตามแบบแปลน/มาตรฐาน", value: "Y" },
        { label: "ขนาดไม่ตรงตามแบบแปลน/มาตรฐาน", value: "N" },
       
    ];

    const pileInlineOptions = [
        { label: "ถูกต้อง", value: "Y" },
        { label: "แก้ไข", value: "N" },
       
    ];

    const display_mode = () => {
        return data.displayMode === "Y" ? true : false;
    };
    const renderRadioLine = (index = 0) => {
        return radioList[index].map((item, index) => {
            return (
                <div className="p-grid p-fluid" key={item.id + "_" + index}>
                    <div className="p-col-12 p-md-1"></div>
                    <div className="p-col-12 p-md-3">
                        <label htmlFor="p-field-radiobutton">{item.label}</label>
                    </div>
                    <div className="p-col-12 p-md-5">
                        <div className="p-grid">
                            <div className="p-col-12 p-md-12">
                            <div className="flex justify-content-center">
                                <SelectButton 
                                id={item.box + "_1"}
                                optionLabel="label" 
                                options={pileInlineOptions} 
                                value={data[item.box]} 
                                onChange={(e) => onInputTextChange(e, item.box)}
                                optionValue="value" 
                                disabled={disabledPage} 
                               
                                />
                                </div>
                                {/* <div className="p-field-radiobutton">
                                    <RadioButton disabled={disabledPage} inputId={item.box + "_1"} name={item.box} id={item.box + "_1"} value="Y" key={item.box + "_1"} checked={data[item.box] === "Y" ? true : false} onChange={(e) => onInputTextChange(e, item.box)} />
                                    <label htmlFor={item.box + "_1"}>ถูกต้อง</label>
                                </div> */}
                            </div>
                            {/* <div className="p-col-12 p-md-6">
                                <div className="p-field-radiobutton">
                                    <RadioButton disabled={disabledPage} iinputId={item.box + "_2"} name={item.box} id={item.box + "_2"} value="N" key={item.box + "_2"} checked={data[item.box] === "N" ? true : false} onChange={(e) => onInputTextChange(e, item.box)} />
                                    <label htmlFor={item.box + "_2"}>แก้ไข</label>
                                </div>
                            </div> */}
                        </div>
                    </div>
                    <div className="p-col-12 p-md-2">
                        {data[item.box] !== undefined && data[item.box] !== " " && !display_mode() ? (
                            <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic(item.codePic)} />
                        ) : (
                            <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                        )}
                        {data[item.box] !== undefined && data[item.box] !== " " ? (
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog(item.codePic)} />
                        ) : (
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                        )}

                        {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" key={item.box + "_btn_2"} onClick={() => onUploadDialog(item.codePic)} /> */}
                    </div>
                    {/* <div className="p-col-12 p-md-1">
                        <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog(item.codePic)} />
                    </div> */}
                    <div className="p-col-12 p-md-1"></div>
                </div>
            );
        });
    };



    const verticalList = [
        [{ id: 1, label: "- เสาเข็ม", box: "pileStandardResult", codePic: "T401" }],
        [
            { id: 1, label: "- เหล็กโครงถัก", box: "trussStandardSteelResult", codePic: "T408" },
            { id: 2, label: "- ลวดเชื่อม", box: "trussWeldingWireResult", codePic: "T409" },
            { id: 3, label: "- สีรองพื้น (สีเทา)", box: "trussPrimerResult", codePic: "T410" },
            { id: 4, label: "- รอยเชื่อม", box: "trussWeldResult", codePic: "T411" },
        ],
    ];

    const renderRadioVertical = (input = 0) => {
        return verticalList[input].map((item, index) => {
            return (
                <div className="p-grid p-fluid" key={item.id + "_" + index}>
                    {/* {input === 1 ? <div className="p-col-12 p-md-12"></div> : ""} */}
                      {input === 1 ? <div className="p-col-12 p-md-1"></div> : ""} 
                    <div className="p-col-12 p-md-2">
                        <label htmlFor="p-field-radiobutton">{item.label}</label>
                    </div>

                    <div className={"p-col-7"}>
                        <div className="p-grid">
                            <div className="p-col-12">
                            <div className="flex justify-content-center">
                                <SelectButton 
                                id={item.box + "_1"}
                                optionLabel="label" 
                                options={verticalOptions} 
                                value={data[item.box]} 
                                onChange={(e) => onInputTextChange(e, item.box)}
                                optionValue="value" 
                                disabled={disabledPage} 
                               
                                />
                                </div>
                                {/* <div className="p-field-radiobutton">
                                    <RadioButton disabled={disabledPage} inputId={item.box + "_1"} name={item.box} id={item.box + "_1"} value="Y" key={item.box + "_1"} checked={data[item.box] === "Y" ? true : false} onChange={(e) => onInputTextChange(e, item.box)} />
                                    <label htmlFor={item.box + "_1"}>ตรงตามแบบแปลน/มาตรฐาน</label>
                                </div> */}
                            </div>
                            {/* <div className="p-col-12 p-md-12">
                                <div className="p-field-radiobutton">
                                    <RadioButton disabled={disabledPage} inputId={item.box + "_2"} name={item.box} id={item.box + "_2"} value="N" key={item.box + "_2"} checked={data[item.box] === "N" ? true : false} onChange={(e) => onInputTextChange(e, item.box)} />
                                    <label htmlFor={item.box + "_2"}>ขนาดไม่ตรงตามแบบแปลน/มาตรฐาน</label>
                                </div>
                            </div> */}
                        </div>
                    </div>

                    <div className="p-col-12 p-md-2">
                        {data[item.box] !== undefined && data[item.box] !== " " && !display_mode() ? (
                            <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} onClick={() => uploadPic(item.codePic)} />
                        ) : (
                            <img title="อัปโหลดรูป" alt="อัปโหลดรูป" src="assets/layout/images/Upload_a_picture.png" style={{ width: 35, height: 35 }} />
                        )}
                        {data[item.box] !== undefined && data[item.box] !== " " ? (
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog(item.codePic)} />
                        ) : (
                            <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} />
                        )}
                        {/* <Button className="p-button-info p-button p-md-12 " icon="pi pi-image" label="รูปถ่าย" key={item.box + "_btn_2"} onClick={() => onUploadDialog(item.codePic)} /> */}
                    </div>
                    {/* <div className="p-col-12 p-md-1">
                        <img title="รูป" alt="รูป" src="assets/layout/images/gallery.png" style={{ width: 35, height: 35 }} onClick={() => onUploadDialog(item.codePic)} />
                    </div> */}
                    <div className="p-col-12 p-md-1"></div>
                </div>
            );
        });
    };

    return (
        <div>
            <div className="p-grid  p-fluid">
                <div className="p-col-12 p-md-12">
                    <h5 className="p-no-box line-under">
                        <b>การตรวจสอบงานโครงสร้าง</b>
                    </h5>
                </div>
                <div className="p-col-12 p-md-6">
                    {renderRadioVertical(0)}

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="p-field-radiobutton">- การตอกเสาเข็ม</label>
                        </div>
                    </div>
                    {renderRadioLine(0)}

                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="p-field-radiobutton">- การเทคอนกรีตโครงสร้าง</label>
                        </div>
                    </div>
                    {renderRadioLine(1)}
                </div>

                <div className="p-col-12 p-md-6">
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-12">
                            <label htmlFor="p-field-radiobutton">- งานโครงถัก (TRUSS)</label>
                        </div>
                        <div className="p-col-12 p-md-12"></div>
                    </div>

                    {renderRadioVertical(1)}
                </div>
            </div>
        </div>
    );
}
